module.exports = __webpack_public_path__ + "news_site.bg.99ed52ac0538e3b05f87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news_site.bg.png
// module id = 662
// module chunks = 2